import React from "react";
import style from "./woundReportCard.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { setLoading } from "../../app/appSlice";
import Spreadsheet from "../../static/images/ExportSpredsheet.svg";
import { OverviewCard } from "./overviewCard";

export const WoundReportCard = ({ optionSelected, selectedDivOption }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const overViewData = useSelector((state) => state.woundreport.overViewData);

  const pdfPage = () => {
    dispatch(setLoading(true));
    history.push("/woundReport/pdfdownload");
  };

  const handleOveriview = (type) => {
    optionSelected("Patients with Wound");
    dispatch(setLoading(false));
    history.push({
      pathname: `woundReport/${type}`,
      state: true,
    });
  };

  const overviewConfig = [
    {
      title: "All Wounds",
      selected: "Patients with Wound",
      count1: overViewData?.patientWithWound?.count,
    },
    {
      title: "All Pressure Injuries",
      subTitle: <span className={style.circulation_problems}>(All classifications)</span>,
      selected: "Pressure Injury POA",
      count1: overViewData?.piPOA?.count,
      count2: overViewData?.piPOA?.percent,
    },
    {
      title: "Pressure Injuries",
      subTitle: <span className={style.dash_stage}>(Stage 1, 2, DTPI, MMPI)</span>,
      selected: "Pressure Injury Non-POA (Stage 1, 2, DTPI, MMPI)",
      count1: overViewData?.piNonPOAStageMMPI?.count,
      count2: overViewData?.piNonPOAStageMMPI?.percent,
    },
    {
      title: "Pressure Injuries",
      subTitle: <span className={`${style.dash_stage} ${style.dash_color}`}>(Stage 3, 4, Unstageable)</span>,
      selected: "Pressure Injury Non-POA (Stage 3, 4, Unstageable)",
      count1: overViewData?.piNonPOAUnStageable?.count,
      count2: overViewData?.piNonPOAUnStageable?.percent,
    },
    {
      title: "All Non-Pressure Injuries",
      selected: "Other",
      count1: overViewData?.other?.count,
      count2: overViewData?.other?.percent,
    },
    {
      title: "Non-Pressure Injuries",
      subTitle: <span className={style.circulation_problems}>(Circulation Problems)</span>,
      selected: "Other (Circulation Problems)",
      count1: overViewData?.otherCirculationProblems?.count,
      count2: overViewData?.otherCirculationProblems?.percent,
    },
  ];

  const overviewBottomConfig = [
    {
      label: "Patients with active wounds",
      value: overViewData?.patientCount || "",
      testId: "patientWithActiveWounds",
      clickable: true,
      key: "patientWithActiveWounds",
    },
    {
      label: "Active wounds that are not resolved",
      value: overViewData?.activeWound || "",
      testId: "activeWoundsNotResolved",
      clickable: true,
      key: "activeWoundsNotResolved",
    },
    {
      label: "Average number of wounds per patient",
      value: overViewData?.avgWoundPerPatient || "",
    },
    {
      label: "Average number of assessments per wound",
      value: overViewData?.avgAssessmentPerWound || "",
    },
    {
      label: "Healing rate",
      value: overViewData?.healingRate !== false && overViewData?.healingRate !== undefined ? `${overViewData.healingRate}%` : "",
    },
  ];

  return (
    <div className={style.overview_blk}>
      <div className={style.overview_top}>
        <p className={style.overview_title}>Overview</p>
        <span className={style.down_spread} onClick={pdfPage}>
          <img src={Spreadsheet} alt="" />
          <label> Download as PDF </label>
        </span>
      </div>

      <div className={style.overview_btm}>
        {overviewBottomConfig.map((item, index) => (
          <p key={index}>
            <label>{item.label}</label>
            <span
              className={item.clickable ? style.commonCusrsor : ""}
              data-testid={item.testId}
              onClick={item.clickable ? () => handleOveriview(item.key) : undefined}
            >
              {item.value}
            </span>
          </p>
        ))}
      </div>

      <div className={style.overview_score}>
        {overviewConfig.map((item, index) => (
          <OverviewCard
            key={index}
            title={item.title}
            subTitle={item.subTitle}
            selectedDivOption={selectedDivOption}
            optionSelected={optionSelected}
            selected={item.selected}
            count1={item.count1}
            count2={item.count2}
          />
        ))}
      </div>
    </div>
  );
};
